type Tone = 'neutral' | 'primary' | 'accent' | 'secondary';

interface MemberStatCardProps {
  label: string;
  value: number;
  icon: string;
  tone: Tone;
  active?: boolean;
  onClick?: () => void;
}

const toneStyles: Record<Tone, { icon: string; value: string }> = {
  neutral: { icon: 'bg-background-200 text-foreground-700', value: 'text-foreground-950' },
  primary: { icon: 'bg-primary-100 text-primary-700', value: 'text-primary-700' },
  accent: { icon: 'bg-accent-100 text-accent-700', value: 'text-accent-700' },
  secondary: { icon: 'bg-secondary-100 text-secondary-800', value: 'text-secondary-900' },
};

export default function MemberStatCard({
  label,
  value,
  icon,
  tone,
  active,
  onClick,
}: MemberStatCardProps) {
  const styles = toneStyles[tone];

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full items-center gap-3 rounded-lg border p-4 text-left transition-colors ${
        active
          ? 'border-primary-300 bg-background-50'
          : 'border-background-200 bg-background-50 hover:bg-background-100'
      }`}
    >
      <span className={`flex h-10 w-10 items-center justify-center rounded-lg ${styles.icon}`}>
        <i className={`${icon} text-lg`}></i>
      </span>
      <div className="min-w-0">
        <p className="text-xs text-foreground-500">{label}</p>
        <p className={`text-xl font-bold ${styles.value}`}>{value}명</p>
      </div>
    </button>
  );
}